var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchvertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Switch vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.25 14.75V5M8.25 5L5 8.25M8.25 5L11.5 8.25M16.375 8.25V18M16.375 18L19.625 14.75M16.375 18L13.125 14.75",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchvertical);
export default __webpack_public_path__ + "static/media/Switch vertical.a10ee6bbc79e266d70ab319501f18ff2.svg";
export { ForwardRef as ReactComponent };